(function (window, document, $) {

    $(document).ready(function () {
        // School filter ===============================================================================================

        function updateSchoolFilter(e) {

            var $filterForm = $('.js-school-filter'),
                $placeInput = $('#school-filter-search-place'),
                $searchInput = $('#school-filter-search');



            if (e !== null) {

                if (e.target.id === 'school-filter-search-place') {
                    $('input[type="checkbox"]').prop('checked', false);
                    $searchInput.val('');
                }
                if (e.target.type === 'checkbox') {
                    $placeInput.val('');
                    $searchInput.val('');
                }
                if (e.target.id === 'school-filter-search') {
                    $('input[type="checkbox"]').prop('checked', false);
                }
                if (e.target.id === 'alle-scholen') {
                    $('input[type="checkbox"]').prop('checked', false);
                    $placeInput.val('');
                    $searchInput.val('');
                    $('#alle-scholen').prop('checked', true);
                }

                window.xhrPool.abortAll();

                $.ajax({
                    type: 'POST',
                    url: themevars.ajaxurl,
                    data: $filterForm.serialize(),
                    dataType: 'json',

                    complete: function (e) { },

                    success: function (response) {

                        var $target = $('[data-filter-target="school"]');
                        $target.empty();

                        if (!response.posts) {
                            var $newEl = $('<div class="filter-no-results ms-item col-xl-12 col-lg-12 col-md-12 col-12">Helaas, er zijn geen resultaten gevonden.</div>');
                            $newEl
                                .css('opacity', 0)
                                .appendTo($target)
                                .delay(i * 100)
                                .animate({ opacity: 1 });
                        } else {
                            for (var i in response.posts) {
                                var $wrapper = $('#school-filter-ajax-template').clone();
                                $wrapper
                                    .removeClass('d-none')
                                    .css('opacity', 0)
                                    .empty()
                                    .html($(response.posts[i].html))
                                    .appendTo($target)
                                    .delay(i * 100)
                                    .animate({ opacity: 1 });
                            }
                        }
                    },
                    error: function (e) { }
                });
            }
        }

        updateSchoolFilter(null);
        $('body').on('change', '.school-filter input, .school-filter select', updateSchoolFilter);

        // trigger change when querystring filter is present
        //if (window.location.search.indexOf('search') != -1) {
        //    $('#school-filter-search').trigger('change');
        //}
    });

}(window, document, jQuery));
